import { DefinisciFascicoloRequest } from '../../../models/dto/definisci-fascicolo-request';
import { Fascicolo } from '../../../models/fascicolo/fascicolo';

export class DefinisciFascicoloAdapter {

  definisciFascicoloRequest: DefinisciFascicoloRequest = new DefinisciFascicoloRequest();

  constructor(fascicolo: Fascicolo) {
    if (fascicolo) {
      this.definisciFascicoloRequest.idFascicolo = fascicolo.id;
      this.definisciFascicoloRequest.idPratica = fascicolo.idParent;
      this.definisciFascicoloRequest.idMotivoDefinizione = (fascicolo.motivoDefinizione) ? fascicolo.motivoDefinizione.id : null;
      this.definisciFascicoloRequest.dataDefinizione = fascicolo.dataDefinizione;
    }
  }
}
